// extracted by mini-css-extract-plugin
export default {"container":"varieties-input_container__JGDWb","label":"varieties-input_label__l8QKf","select":"varieties-input_select__hZpPK"};